import {
  Box,
  Button,
  Container,
  Heading,
  List,
  ListIcon,
  ListItem,
  Text,
  VStack,
} from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'
import { FiCheckCircle } from 'react-icons/fi'

export const ObjectsAndBlocksPage: React.FC = () => {
  return (
    <Container maxW="container.xl" py={8}>
      <VStack align="stretch" spacing={6}>
        <Box>
          <Heading as="h1" size="2xl" color="brand.500" mb={3}>
            🏗️ Объекты и блоки
          </Heading>
          <Text color="gray.600" fontSize="lg">
            Объекты — это места/направления работ. Блоки — это конкретные задачи
            в графике. Чтобы график был чистым, сначала поддерживайте порядок в объектах.
          </Text>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Как вести объекты</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Создавайте объект сразу с понятным названием.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Не дублируйте одинаковые объекты с разным написанием.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Перед началом недели проверьте, что список объектов актуален.</ListItem>
          </List>
        </Box>

        <Box>
          <Heading size="md" mb={3}>Как связаны с графиком</Heading>
          <List spacing={2}>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Каждый блок в графике относится к конкретному объекту.</ListItem>
            <ListItem><ListIcon as={FiCheckCircle} color="green.500" />Если объекта нет или он создан неверно — план будет неудобно читать.</ListItem>
          </List>
        </Box>

        <Box>
          <Button as={RouterLink} to="/schedule" mr={3} variant="outline">Открыть график</Button>
          <Button as={RouterLink} to="/brigades" variant="outline">Открыть бригады</Button>
        </Box>
      </VStack>
    </Container>
  )
}
